import { FormSection, GridContainer, GridItem, TextareaFormField } from "@duosoftbg/nacid-components";

const RequestNotesSection = () => {
  return (
    <FormSection label={"t.arUniEntryRequest.notes"}>
      <GridContainer spacing={4} mt={0}>
        <GridItem sm={12} md={12}>
          <TextareaFormField labelCode={"l.arUniEntryRequest.notes"} fieldName={"notes"} />
        </GridItem>
      </GridContainer>
    </FormSection>
  );
};
export default RequestNotesSection;
